(function(){
  'use strict';

  var root = document.documentElement;
  var safetyTimer = 0;
  var loaderScript = document.currentScript;
  var logoUrl = '';
  var loaderEl = null;

  try {
    if(loaderScript && loaderScript.src) logoUrl = new URL('drops-logo.png', loaderScript.src).href;
  } catch(e) {}

  function ensurePageLoader(){
    if(loaderEl && document.documentElement.contains(loaderEl)) return loaderEl;

    loaderEl = document.getElementById('drops-page-loader');
    if(loaderEl) return loaderEl;

    if(!document.body) return null;

    loaderEl = document.createElement('div');
    loaderEl.id = 'drops-page-loader';
    loaderEl.setAttribute('aria-hidden', 'true');
    loaderEl.innerHTML =
      '<div class="drops-page-loader__mark">' +
        '<span class="drops-page-loader__outline"></span>' +
        '<img class="drops-page-loader__logo" src="' + logoUrl + '" alt="">' +
        '<span class="drops-page-loader__water"><span class="drops-page-loader__liquid"></span></span>' +
      '</div>';
    document.body.appendChild(loaderEl);
    return loaderEl;
  }

  function hidePageLoader(){
    window.clearTimeout(safetyTimer);
    root.classList.remove('drops-page-loading');
  }

  function showPageLoader(){
    ensurePageLoader();
    window.clearTimeout(safetyTimer);
    root.classList.remove('drops-page-loading');
    void root.offsetWidth;
    root.classList.add('drops-page-loading');

    var maxVisible = (window.Shopify && Shopify.designMode) ? 320 : 650;
    safetyTimer = window.setTimeout(hidePageLoader, maxVisible);
  }

  if(!document.getElementById('drops-page-loader-style')){
    var style = document.createElement('style');
    style.id = 'drops-page-loader-style';
    style.textContent = [
      '#drops-page-loader{position:fixed;inset:0;z-index:2147483638;display:flex;align-items:center;justify-content:center;background:rgba(248,251,255,.965);opacity:0;visibility:hidden;pointer-events:none;transition:opacity .08s linear,visibility 0s linear .08s}',
      'html.drops-page-loading #drops-page-loader{opacity:1;visibility:visible;pointer-events:auto;transition:opacity .06s linear}',
      '.drops-page-loader__mark{position:relative;width:112px;height:125px;isolation:isolate;filter:drop-shadow(0 10px 20px rgba(11,55,121,.13))}',
      '.drops-page-loader__mark:before{content:"";position:absolute;left:50%;top:50%;width:142px;height:142px;transform:translate(-50%,-50%);border-radius:50%;background:rgba(255,255,255,.93);box-shadow:0 0 0 1px rgba(22,67,144,.10),0 10px 34px rgba(20,72,145,.08);z-index:-2}',
      '.drops-page-loader__outline{position:absolute;inset:0;z-index:-1;background:#183f91;-webkit-mask:url("' + logoUrl + '") center/contain no-repeat;mask:url("' + logoUrl + '") center/contain no-repeat;transform:scale(1.055);transform-origin:center;filter:drop-shadow(0 0 1px #183f91) drop-shadow(0 0 2px rgba(24,63,145,.55))}',
      '.drops-page-loader__logo{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;z-index:1}',
      '.drops-page-loader__water{position:absolute;inset:0;z-index:2;overflow:hidden;-webkit-mask:url("' + logoUrl + '") center/contain no-repeat;mask:url("' + logoUrl + '") center/contain no-repeat;pointer-events:none}',
      '.drops-page-loader__liquid{position:absolute;left:-18%;top:0;width:136%;height:118%;transform:translate3d(0,100%,0);background:linear-gradient(180deg,rgba(45,196,230,.62) 0%,rgba(0,147,209,.68) 48%,rgba(24,63,145,.72) 100%);will-change:transform}',
      '.drops-page-loader__liquid:before{content:"";position:absolute;left:-8%;top:-8px;width:116%;height:18px;border-radius:48% 52% 46% 54%;background:rgba(121,225,243,.76);box-shadow:0 -2px 5px rgba(255,255,255,.42) inset;transform:translate3d(-4%,0,0);will-change:transform}',
      'html.drops-page-loading .drops-page-loader__liquid{animation:dropsWaterRise .56s cubic-bezier(.22,.75,.24,1) forwards}',
      'html.drops-page-loading .drops-page-loader__liquid:before{animation:dropsWaterWave .26s ease-in-out infinite alternate}',
      '@keyframes dropsWaterRise{0%{transform:translate3d(0,100%,0)}72%{transform:translate3d(0,27%,0)}100%{transform:translate3d(0,18%,0)}}',
      '@keyframes dropsWaterWave{from{transform:translate3d(-4%,0,0) skewX(-2deg)}to{transform:translate3d(4%,1px,0) skewX(2deg)}}',
      '@media(max-width:767px){.drops-page-loader__mark{width:88px;height:99px}.drops-page-loader__mark:before{width:116px;height:116px}}',
      '@media(prefers-reduced-motion:reduce){html.drops-page-loading .drops-page-loader__liquid{animation:none;transform:translate3d(0,22%,0)}html.drops-page-loading .drops-page-loader__liquid:before{animation:none}}'
    ].join('');
    (document.head || root).appendChild(style);
  }

  if(document.body) ensurePageLoader();
  else document.addEventListener('DOMContentLoaded', ensurePageLoader, {once:true});

  window.DropsPageLoader = {
    show: showPageLoader,
    hide: hidePageLoader
  };

  window.addEventListener('click', function(event){
    if(
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    var target = event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;
    if(!link || link.hasAttribute('download') || link.hasAttribute('data-no-page-loader')) return;

    var linkTarget = link.getAttribute('target');
    if(linkTarget && linkTarget !== '_self') return;

    var href = link.getAttribute('href') || '';
    if(!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;

    var url;
    try { url = new URL(link.href, window.location.href); }
    catch(e) { return; }

    if(url.origin !== window.location.origin) return;
    if(url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

    showPageLoader();
  }, false);

  window.addEventListener('pageshow', hidePageLoader);
  hidePageLoader();
})();

(function(){
  var selector = [
    '.prd-image img[data-src]',
    '.prd-image-wrap img[data-src]',
    'product-card img[data-src]',
    '.product-card img[data-src]',
    '.drops-products img[data-src]',
    '.drops-category-card img[data-src]',
    '.drops-promo img[data-src]',
    '.drops-brand img[data-src]',
    '.drops-newslettermodal img[data-src]'
  ].join(',');

  function promoteImage(img){
    if(!img || img.__dropsHdPromoted) return;
    img.__dropsHdPromoted = true;

    var dataSrc = img.getAttribute('data-src');
    var dataSrcset = img.getAttribute('data-srcset');
    var dataSizes = img.getAttribute('data-sizes');

    if(dataSrcset){
      img.setAttribute('srcset', dataSrcset);
      img.removeAttribute('data-srcset');
    }
    if(dataSizes && dataSizes !== 'auto'){
      img.setAttribute('sizes', dataSizes);
      img.removeAttribute('data-sizes');
    }
    if(dataSrc){
      img.setAttribute('src', dataSrc);
      img.removeAttribute('data-src');
    }

    img.setAttribute('loading','eager');
    img.classList.remove('lazyload','lazyloading','fade-up');
    img.classList.add('lazyloaded','drops-eager-product-image');
    img.style.opacity = '1';
    img.style.filter = 'none';
    img.style.transform = 'none';
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      promoteImage(entry.target);
      observer.unobserve(entry.target);
    });
  }, {rootMargin:'320px 0px'}) : null;

  function watchImage(img){
    if(!img || img.__dropsHdObserved || img.__dropsHdPromoted) return;
    img.__dropsHdObserved = true;
    if(observer) observer.observe(img);
  }

  function scan(root){
    var scope = root || document;
    if(scope.matches && scope.matches(selector)) watchImage(scope);
    if(scope.querySelectorAll) scope.querySelectorAll(selector).forEach(watchImage);
  }

  function ready(){
    scan(document);
    document.addEventListener('shopify:section:load', function(event){
      scan(event.target);
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();
